
<!-- --------------------------------------------------------------------------------------------
|  File Name: UAT menu For MSSIDC                                        |   
|  Description: This menu  have utility Menu 
-------------------------------------------------------------------------------------------- -->

<div class="left-side">
  <div class="navbar-brand position-relative top-0 ms-2 pe-3 m-0 p-0 mt-2">
    <div class="fs-6 sidebar-text">Hello {{ name }}</div>
  </div>
  <nav class="navbar navbar-expand-lg position-relative mb-4">
    <div class="collapse navbar-collapse mt-0" id="navbarNav">
      <ul class="ullist" *ngIf="isMSMEUser">
        <li>
          <button id="btnMSMEDashboard" (click)="msme_navigate($event)">
            <i class="bi bi-speedometer2"></i> Dashboard
          </button>
        </li>
        <li>

          <button id="btnMSMEProfile" (click)="toggleMSMEProfileSubMenu()">
            <i class="bi bi-slash-circle"></i>
            <i [ngClass]="{
                'bi-chevron-down': !isDrop,
                'bi-chevron-up': isDrop,
              }" class="bi float-end me-3"></i>
            My Profile
          </button>
          <ul *ngIf="isMyProfileSubMenuVisible" class="ps-3 list-unstyled">
            <li>
              <button id="btnMSMEProfile" (click)="msme_navigate($event)">
                <i class="bi bi-person"></i> User Details
              </button>
            </li>
            <li>
              <button id="btnMSMEOtherDetails" (click)="msme_navigate($event)">
                <i class="bi bi-list"></i> Other Details
              </button>
            </li>
          </ul>
        </li>

        <li>
          <button id="btnMSMEViewEvents" (click)="msme_navigate($event)">
            <i class="bi bi-eye"></i> View Events
          </button>
        </li>
        <li>
          <button id="btnGrievances" (click)="msme_navigate($event)">
            <i class="bi bi-slash-circle"></i> Grievance Dashboard
          </button>
        </li>
        <li>
          <button id="btnMSMEChangePassword" (click)="msme_navigate($event)" type="submit">
            <i class="bi bi-arrow-clockwise"></i> Change Password
          </button>
        </li>
        <li>
          <button id="btnUserManual" type="submit" (click)="msme_navigate($event)">
            <i class="bi bi-book"></i> User Manual
          </button>
        </li>
        <li>
          <button id="btnLogout" (click)="Logout()" class="logout">
            <i class="bi bi-arrow-right-circle"></i> LogOut
          </button>
        </li>
      </ul>

      <ul class="ullist" *ngIf="isIAUser">
        <li>
          <button id="btnIADashboard" (click)="ia_navigate($event)">
            <i class="bi bi-speedometer2"></i> Dashboard
          </button>
        </li>
        <li>
          <button id="btnIAProfile" (click)="ia_navigate($event)">
            <i class="bi bi-person"></i> Profile
          </button>
        </li>
        <li>
          <button id="btnIAOtherDetails" (click)="ia_navigate($event)">
            <i class="bi bi-list"></i> ESG Compliance
          </button>
        </li>
        <li>
          <button id="btnIAViewProposal" (click)="ia_navigate($event)">
            <i class="bi bi-pencil-square"></i> View Proposal
          </button>
        </li>
        <li>
          <button id="btnViewEvent" (click)="ia_navigate($event)">
            <i class="bi bi-eye"></i> View Events
          </button>
        </li>
        <li>
          <button id="btnInvoiceDashboardIA" (click)="ia_navigate($event)">
            <i class="bi bi-slash-circle"></i> Invoice Dashboard
          </button>
        </li>

        <li>
          <button id="btnIAChangePassword" type="submit" (click)="ia_navigate($event)">
            <i class="bi bi-arrow-clockwise"></i> Change Password
          </button>
        </li>
        <li>
          <button id="btnUserManual" type="submit" (click)="ia_navigate($event)">
            <i class="bi bi-book"></i> User Manual
          </button>
        </li>
        <li>
          <button id="btnLogout" (click)="Logout()" class="logout">
            <i class="bi bi-arrow-right-circle"></i> LogOut
          </button>
        </li>
      </ul>

      <ul class="ullist" *ngIf="isMSSIDCUser && loggedInUserName !== 'RAMP_MSSIDC'">
        <li>
          <button id="btnMSSIDCDashboard" (click)="mssidc_navigate($event)">
            <i class="bi bi-speedometer2"></i> Dashboard
          </button>
        </li>
        <li>
          <button id="btnDynamicDashboard" (click)="mssidc_navigate($event)">
            <i class="bi bi-speedometer"></i> Dynamic Dashboard
          </button>
        </li>
        <li>
          <button id="btnMSSIDCEOI" (click)="mssidc_navigate($event)">
            <i class="bi bi-file-earmark-text"></i> EOI
          </button>
        </li>
        <li><button id="btnMSSIDCEOIExhibition" (click)="mssidc_navigate($event)"><i class="bi bi-file-earmark-text"></i> EOI-Exhibition</button></li>
        <li>
          <button id="btnVerifyMSME" (click)="mssidc_navigate($event)">
            <i class="bi bi-list"></i> Verify MSME
          </button>
        </li>

        <li>
          <button id="btnVerifyProposal" (click)="mssidc_navigate($event)">
            <i class="bi bi-list"></i> Approve Proposal
          </button>
        </li>
        <li>
          <button id="btnViewEvents" (click)="mssidc_navigate($event)">
            <i class="bi bi-eye"></i> View Events
          </button>
        </li>
        <li>
          <button id="btnInvoiceDashboardMSSIDC" (click)="mssidc_navigate($event)">
            <i class="bi bi-slash-circle"></i> Invoice Dashboard
          </button>
        </li>
        <li>
          <button id="btnGrievancesDashboardMSSIDC" (click)="mssidc_navigate($event)">
            <i class="bi bi-slash-circle"></i> Grievance Dashboard
          </button>
        </li>
        <li>
          <button id="btnGrading" (click)="mssidc_navigate($event)">
            <i class="bi bi bi-award"></i> Grading
          </button>
        </li>

        <!-- <li>
          <button id="btnOnSpotAttendance" (click)="mssidc_navigate($event)">
            <i class="bi bi-person-check"></i> Update On the Spot
          </button>
        </li> -->

        <li>
          <button id="btnChangeEventDate" (click)="mssidc_navigate($event)">
            <i class="bi bi-arrow-repeat"></i> Update Event Date
          </button>
        </li>



       

        <li>
          <button id="btnUpdateAttendanceList" (click)="mssidc_navigate($event)">
            <i class="bi bi-arrow-repeat"></i> Update Msme Attendance
          </button>
        </li>

          <li>
          <button id="btnUpdateLoginBanner" (click)="mssidc_navigate($event)">
            <i class="bi bi-arrow-repeat"></i> Update Login Banner
          </button>
        </li>
        <li>
          <button id="btnMaster" (click)="toggleMasterSubMenu()">
            <i class="bi bi-slash-circle"></i>
            <i [ngClass]="{
                'bi-chevron-down': !isDrop,
                'bi-chevron-up': isDrop,
              }" class="bi float-end me-3"></i>
            Master
          </button>
          <ul *ngIf="isMasterSubMenuVisible" class="ps-3 list-unstyled">
            <li>
              <button id="btnUserMaster" (click)="mssidc_navigate($event)">
                <i class="bi bi bi-award"></i> User Master
              </button>
            </li>
            <li>
              <button id="btnInterestMaster" (click)="mssidc_navigate($event)">
                <i class="bi bi-pencil-square"></i> Component
              </button>
            </li>
            <li>
              <button id="btnEventCapacityMaster" (click)="mssidc_navigate($event)">
                <i class="bi bi-pencil-square"></i> Event Capacity
              </button>
            </li>
            <li>
              <button id="btnFocusSectorMaster" (click)="mssidc_navigate($event)">
                <i class="bi bi-pencil-square"></i> Event Focus Sector
              </button>
            </li>
            <li>
              <button id="btnFundMngtMaster" (click)="mssidc_navigate($event)">
                <i class="bi bi-pencil-square"></i> Fund Management
              </button>
            </li>
            <li>
              <button id="btnGreenTechMaster" (click)="mssidc_navigate($event)">
                <i class="bi bi-pencil-square"></i> Green Technology
              </button>
            </li>
            <li>
              <button id="btnInterventionMaster" (click)="mssidc_navigate($event)">
                <i class="bi bi-pencil-square"></i> Intervention
              </button>
            </li>
            <li>
              <button id="btnISOCertiMaster" (click)="mssidc_navigate($event)">
                <i class="bi bi-pencil-square"></i> ISO Certificate List
              </button>
            </li>
            <li>
              <button id="btnNICMaster" (click)="mssidc_navigate($event)">
                <i class="bi bi-pencil-square"></i> NIC
              </button>
            </li>
            <li>
              <button id="btnOrganisationTypeMaster" (click)="mssidc_navigate($event)">
                <i class="bi bi-pencil-square"></i> Organisation Type
              </button>
            </li>
            <li>
              <button id="btnSocialCategoryMaster" (click)="mssidc_navigate($event)">
                <i class="bi bi-pencil-square"></i> Social Category
              </button>
            </li>
            <li>
              <button id="btnTypeEnterpriseMaster" (click)="mssidc_navigate($event)">
                <i class="bi bi-pencil-square"></i> Type Enterprise
              </button>
            </li>

            <li>
              <button id="btnCustomeFeedback" (click)="mssidc_navigate($event)">
                <i class="bi bi-pencil-square"></i> Customize Feedback
              </button>
            </li>
            <li>
              <button id="btnCustomeFeedbackCreate" (click)="mssidc_navigate($event)">
                <i class="bi bi-pencil-square"></i> Add Customize Feedback
                Questions
              </button>
            </li>
            <li>
              <button id="btnMDCDetails" (click)="mssidc_navigate($event)">
                <i class="bi bi-pencil-square"></i> Certificate Signatory
                details
              </button>
            </li>
          </ul>
        </li>
        <li>
          <button id="btnReports" (click)="toggleReportSubMenu()">
            <i class="bi bi-eye"></i>
            <i [ngClass]="{
                'bi-chevron-down': !isDrop,
                'bi-chevron-up': isDrop,
              }" class="bi float-end me-3"></i>
            Reports
          </button>

          <ul *ngIf="isReportSubMenuVisible" class="ps-3 list-unstyled">
            <li>
              <button id="btnRegisteresMSMEList" (click)="mssidc_navigate($event)">
                <i class="bi bi-clipboard-check"></i> All Registered MSME
              </button>
            </li>
            <li>
              <button id="btnRegisteresIAList" (click)="mssidc_navigate($event)">
                <i class="bi bi-clipboard-check"></i> All Registered IA
              </button>
            </li>
            <li>
              <button id="btnTotalEventList" (click)="mssidc_navigate($event)">
                <i class="bi bi-calendar"></i> All Events
              </button>
            </li>
            <li>
              <button id="btnTotalProposalList" (click)="mssidc_navigate($event)">
                <i class="bi bi-file-earmark-text"></i> All Proposals
              </button>
            </li>
            <li>
              <button id="btnCancelPostponeEventList" (click)="mssidc_navigate($event)">
                <i class="bi bi-calendar"></i> Cancel/Postpone Events
              </button>
            </li>
            <li>
              <button id="btnCompletedEventList" (click)="mssidc_navigate($event)">
                <i class="bi bi-calendar"></i> Completed Events
              </button>
            </li>
            <li>
              <button id="btnDistrictWiseTrainingList" (click)="mssidc_navigate($event)">
                <i class="bi bi-geo-alt"></i> District wise Training/Workshop
              </button>
            </li>
            <li>
              <button id="btnIaBankDetails" (click)="mssidc_navigate($event)">
                <i class="bi bi-person"></i> IA Bank Details
              </button>
            </li>
            <li>
              <button id="btnMISDetails" (click)="mssidc_navigate($event)">
                <i class="bi bi-calendar"></i> MIS Details
              </button>
            </li>
            <li>
              <button id="btnParticipantList" (click)="mssidc_navigate($event)">
                <i class="bi bi-calendar"></i> Participants Details
              </button>
            </li>
            <li>
              <button id="btnScheduledEventList" (click)="mssidc_navigate($event)">
                <i class="bi bi-calendar"></i> Scheduled Events
              </button>
            </li>
            <li>
              <button id="btnCompletedInvoiceList" (click)="mssidc_navigate($event)">
                <i class="bi bi-calendar"></i> Completed Invoice
              </button>
            </li>
          </ul>
        </li>
        <li>
          <button id="btnMSSIDCChangePassword" (click)="mssidc_navigate($event)">
            <i class="bi bi-arrow-clockwise"></i> Change Password
          </button>
        </li>

        <li>
          <button id="btnIAUserManual" (click)="toggleUserManualSubMenu()">
            <i class="bi bi-journal-bookmark"></i>
            <i [ngClass]="{
                'bi-chevron-down': !isDrop,
                'bi-chevron-up': isDrop,
              }" class="bi float-end me-3"></i>
            User Manual
          </button>
          <ul *ngIf="isUserManualSubMenuVisible" class="ps-3 list-unstyled">
            <li>
              <button id="btnIAUserManual" (click)="mssidc_navigate($event)">
                <i class="bi bi-book"></i> IA
              </button>
            </li>
            <li>
              <button id="btnMSMEUserManual" (click)="mssidc_navigate($event)">
                <i class="bi bi-book"></i> MSME
              </button>
            </li>
          </ul>
        </li>

        <li>
          <button id="btnLogout" (click)="Logout()" class="logout">
            <i class="bi bi-arrow-right-circle"></i> LogOut
          </button>
        </li>
      </ul>

      <ul class="ullist" *ngIf="isMSSIDCUser && loggedInUserName === 'RAMP_MSSIDC'">
        <li>
          <button id="btnViewEvents" (click)="mssidc_navigate($event)">
            <i class="bi bi-eye"></i> View Events
          </button>
        </li>
        <li>
          <button id="btnReports" (click)="toggleReportSubMenu()">
            <i class="bi bi-eye"></i>
            <i [ngClass]="{
                'bi-chevron-down': !isDrop,
                'bi-chevron-up': isDrop,
              }" class="bi float-end me-3"></i>
            Reports
          </button>

          <ul *ngIf="isReportSubMenuVisible" class="ps-3 list-unstyled">
            <li>
              <button id="btnMISDetails" (click)="mssidc_navigate($event)">
                <i class="bi bi-calendar"></i> MIS Details
              </button>
            </li>
          </ul>
        </li>

        <li>
          <button id="btnLogout" (click)="Logout()" class="logout">
            <i class="bi bi-arrow-right-circle"></i> LogOut
          </button>
        </li>
      </ul>

      <ul class="ullist" *ngIf="isDICUser">
        <li>
          <button id="btnDICDashboard" (click)="dic_navigate($event)">
            <i class="bi bi-speedometer2"></i> Dashboard
          </button>
        </li>
        <li>
          <button id="btnViewEvents" (click)="dic_navigate($event)">
            <i class="bi bi-calendar"></i> View Events
          </button>
        </li>
        <li>
          <button id="btnReports" (click)="toggleReportSubMenu()">
            <i class="bi bi-eye"></i>
            <i [ngClass]="{
                'bi-chevron-down': !isDrop,
                'bi-chevron-up': isDrop,
              }" class="bi float-end me-3"></i>
            Reports
          </button>

          <ul *ngIf="isReportSubMenuVisible" class="ps-3 list-unstyled">
            <li>
              <button id="btnTotalEventList" (click)="dic_navigate($event)">
                <i class="bi bi-calendar"></i> All Events
              </button>
            </li>
            <li>
              <button id="btnCancelPostponeEventList" (click)="dic_navigate($event)">
                <i class="bi bi-calendar"></i> Cancel/Postpone Events
              </button>
            </li>
            <li>
              <button id="btnCompletedEventList" (click)="dic_navigate($event)">
                <i class="bi bi-calendar"></i> Completed Events
              </button>
            </li>
            <li>
              <button id="btnDistrictWiseTrainingList" (click)="dic_navigate($event)">
                <i class="bi bi-geo-alt"></i> District wise Training/Workshop
              </button>
            </li>
            <li>
              <button id="btnScheduledEventList" (click)="dic_navigate($event)">
                <i class="bi bi-calendar"></i> Scheduled Events
              </button>
            </li>
          </ul>
        </li>
        <li>
          <button id="btnDICChangePassword" type="submit" (click)="dic_navigate($event)">
            <i class="bi bi-arrow-clockwise"></i> Change Password
          </button>
        </li>
        <li>
          <button id="btnLogout" (click)="Logout()" class="logout">
            <i class="bi bi-arrow-right-circle"></i> Log Out
          </button>
        </li>
      </ul>
    </div>
  </nav>
</div>
